import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Title, Dot } from "../styles/GlobalStyles";

// const CurvedSection = styled.section`
//   position: relative;
//   background: #eef5ff;
//   height: 50vh;
// `;
// const Weawe = styled.div`
//   position: absolute;
//   height: 198px;
//   width: 100%;
//   background: #eef5ff;
//   bottom: 0;

//   &::before,
//   &::after {
//     content: '';
//     display: block;
//     position: absolute;
//     border-radius: 100% 50%;
//   }
//   &::before {
//     width: 55%;
//     height: 109%;
//     background-color: #fff;
//     right: -1.5%;
//     top: 60%;
//   }
//   &::after {
//     width: 55%;
//     height: 100%;
//     background-color: #eef5ff;
//     left: -1.5%;
//     top: 40%;
//   }
// `;

export default function About2022() {
  return (
    <>
      {/* <div className="bg-dv2021-100 pb-6">
        <section className="text-gray-700 body-font container mx-auto">
          <div className="container px-5 py-24 mx-auto">
            <Polygon>
              <Title>
                2021<Dot>.</Dot>
              </Title>
            </Polygon>
            <p className="text-lg sm:text-2xl font-medium sm:leading-10 space-y-6 mb-6 text-gray-700 font-inter">
              Tako kot vedno do sedaj, bomo na konferenci ponudili prostor za široko razpravo o
              zagotavljanju varnosti, zato si želimo prispevkov, ki bodo ta družbeni pojav naslovili
              v vsej njegovi kompleksnosti in celovitosti. Z osrednjo okroglo mizo bomo obeležili{' '}
              <span className="font-bold">
                30. obletnico delovanja slovenskih varnostnih sil v osamosvojitveni vojni
              </span>
              , ostale okrogle mize in tematske sekcije pa bodo med drugim posvečene{' '}
              <span className="font-bold">>nadzoru nad delom policije</span>,{' '}
              <span className="font-bold">viktimizacijski študiji v ruralnih okoljih</span>,
              <span className="font-bold">pluralni policijski dejavnosti</span>,{' '}
              <span className="font-bold">jeziku stroke</span>,{' '}
              <span className="font-bold">gospodarski kriminaliteti v zdravstvu</span>,{' '}
              <span className="font-bold">informacijski varnosti</span> in drugim varstvoslovnim
              temam.
            </p>
          </div>
        </section>
      </div> */}
      <div className="bg-teal-50 pb-6">
        <section className="body-font container mx-auto text-gray-700">
          <div className="container mx-auto flex flex-wrap px-5 py-4">
            <div className="mx-auto mb-8 flex flex-wrap items-stretch">
              <div className="mb-10 flex flex-col place-content-between border-teal-500 md:mb-0 md:w-1/5 md:border-r-4 md:border-b-0 md:pr-12">
                {/* <Title className="md:transform md:-rotate-90 md:origin-bottom md:ml-20 md:mt-24 lg:transform-none lg:ml-0 lg:mt-0"> */}
                <Title className="sm:origin-bottom-right sm:-rotate-90">
                  2022<Dot>.</Dot>
                </Title>
              </div>
              <div className="font-inter text-base md:w-4/5 md:pl-12">
                {/* <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
                  Po priporočilu Nacionalnega inštituta za javno zdravje bomo
                  letošnjo konferenco izvedli v e-okolju. V program, ki bo na
                  spletni strani objavljen v kratkem, bomo uvrstili sprejete
                  prispevke in okrogle mize, prijavljeni udeleženci pa boste po
                  e-pošti pravočasno prejeli povezavo do dogodka.
                </p>
                <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
                  Udeležba na konferenci je{" "}
                  <span className="font-bold">brezplačna</span>, vas pa prosimo,
                  da se na dogodek{" "}
                  <Link
                    to="/prijavnica/"
                    className="text-dv2021-600 font-bold underline"
                  >
                    prijavite
                  </Link>
                  , v kolikor se še niste. Prijavni rok podaljšujemo do 31. maja
                  2021.
                </p> */}

                <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
                  Tema osrednje okrogle mize bo{" "}
                  <span className="font-bold">
                    nasilje v družini - epidemija, pred katero si prepogosto
                    zatiskamo oči, mašimo ušesa in zastiramo usta
                  </span>
                  .
                </p>

                <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
                  Nasilje v družini razumemo kot katero koli obliko psihičnega,
                  fizičnega, spolnega, ekonomskega nasilja, zanemarjanja in
                  zalezovanja, ki poteka v družinskem okolju. Tovrstno nasilje
                  je lahko nasilje do otrok, nasilje v intimnopartnerskih
                  odnosih ter tudi preveč pogosto zapostavljeno nasilje do
                  starejših. Nesporno dejstvo je, da je v družbi najbolj
                  poznano, opazno in tudi najmanj tolerirano fizično nasilje,
                  medtem ko druge oblike nasilja nemalokrat ostanejo javnosti
                  prikrite. V preteklosti je namreč veljalo prepričanje, da je
                  nasilje v družini zasebni problem družine, v katerega družba
                  ne posega. Vidne spremembe na tem področju so se začele
                  dogajati šele v 80. letih prejšnjega stoletja z združitvijo
                  različnih sil, ki so povzročile zakonodajne in tudi politične
                  in posledično družbene spremembe. Odnos do nasilja v družini
                  se je začel pomembno spreminjati tudi v našem okolju. V
                  zadnjem času, še posebej v obdobju restrikcij zaradi pandemije
                  novega koronavirusa in spodbujeno s kampanjo na Twitterju pod
                  okriljem ključnika #MeToo, #NisemPrijavila oziroma
                  #NisamPrijavila, je spregovorilo na tisoče žrtev nasilja na
                  Balkanu in v Sloveniji. Na Inštitutu 8. marec so zbrali na
                  desetine pričevanj žrtev intimnopartnerskega nasilja, kar
                  zgolj utrjuje spoznanje, da je nasilja v družinskem okolju ali
                  v intimnopartnerskih zvezah ogromno, in da ga zelo veliko
                  ostaja skritega.
                </p>

                <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
                  <Link to="/o2022/" className="text-dv2021-600 underline">
                    Več o temi osrednje okrogle mize.
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
